<div class="m-1" [class.invalid]="invalid()">
    @if (AdaaHelper.isDefinedAndNotEmpty(label())) {
        <label class="form-label">
            {{ label() }}
            @if (isRequired()) {
                <span class="form-required text-danger fw-bolder">*</span>
            }
        </label>
    }

    <div class="input-group">
        <span class="input-group-text">{{ fromLabel() | translate }}</span>

        <input
            type="number"
            class="form-control"
            [class.is-invalid]="invalid()"
            [id]="effectiveControlId() + '-from'"
            [placeholder]="fromPlaceholder()"
            [value]="fromValue"
            (change)="valueChanged($event, true)"
        />
        <span class="px-2"></span>

        <span
            class="input-group-text"
            [class.rounded-end]="languageService.direction() !== 'ltr'"
            [class.rounded-start-0]="languageService.direction() !== 'ltr'"
        >
            {{ toLabel() | translate }}
        </span>

        <input
            type="number"
            class="form-control"
            [class.is-invalid]="invalid()"
            [id]="effectiveControlId() + '-to'"
            [placeholder]="toPlaceholder()"
            [value]="toValue"
            (change)="valueChanged($event, false)"
        />
    </div>
</div>
